export default __webpack_public_path__ + "locales/bg/DeleteDialog.json?hash=a04d201d9d1ab74fcf386d4c7457345b";